export * from "./product-portal-api-urls";
export * from "./product-portal-web-repository";